<div class="stFooter">
  <br>
  <div class="row pt-4 pb5">
    <div class="col-md-3">
    </div>
    <div class="col-md-2">
      <a href="https://www.scalanthropy.com" target="_blank">
        <img src="assets/images/Scalanthropy_logo-TM-WHITE.avif"  alt="Logo" width="225" height="90" class="display-2 d-inline-block align-text-top">
      </a>
    </div>
    <div class="col-md-1">
      <a href="https://www.scalanthropy.com/how-we-work" target="_blank" class="webtext-white no-underline">
        How We Work
      </a><br>
      <a href="https://www.scalanthropy.com/who-we-serve" target="_blank" class="webtext-white no-underline">
        Who We Serve
      </a><br>
      <a href="https://www.scalanthropy.com/nonprofits" target="_blank" class="webtext-white no-underline">
        Pricing
      </a><br>
    </div>
    <div class="col-md-1">
      <a href="https://www.scalanthropy.com/about" target="_blank" class="webtext-white no-underline">
        About
      </a><br>
      <a href="https://www.scalanthropy.com/guides" target="_blank" class="webtext-white no-underline">
        Resources
      </a><br>
      <a href="https://www.scalanthropy.com/contact" target="_blank" class="webtext-white no-underline">
        Contact
      </a><br>
    </div>
    <div class="col-md-3">
      <a href="https://www.linkedin.com/company/scalanthropy" target="_blank">
        <img src="assets/images/linkedin_logo.avif"  alt="Logo" width="40" height="40">
      </a>&nbsp;&nbsp;
      <a href="https://www.instagram.com/scalanthropy/" target="_blank">
        <img src="assets/images/instagram_logo.avif"  alt="Logo" width="40" height="40">
      </a>&nbsp;&nbsp;
      <a href="https://www.scalanthropy.com/about" target="_blank">
        <img src="assets/images/facebook_logo.avif"  alt="Logo" width="40" height="40">
      </a><br><br>
      <a href="https://www.scalanthropy.com/terms-conditions" target="_blank" class="webtext-white no-underline">
        Terms & Conditions
      </a><span class="webtext-white"> | </span>
      <a href="https://www.scalanthropy.com/privacy-policy" target="_blank" class="webtext-white no-underline">
        Privacy Policy
      </a><br>
      <p class="webtext-white">© 2025 Scalanthropy. All rights reserved.</p>
    </div>
    <div class="col-md-2">

    </div>
  </div>
  <br><br>
</div>
